import { createSlice } from "@reduxjs/toolkit";

const deviceDetailSlice = createSlice({
    name: "deviceDetailSetup",
    initialState: {
        deviceDetailData: null,
    },
    reducers: {
      setDeviceDetailData: (state, action) => {
        state.deviceDetailData = action?.payload
      },
    }
  });


// this is for dispatch
export const { deviceDetailData } = deviceDetailSlice.actions;

// this is for configureStore
export default deviceDetailSlice.reducer;